import getAllBonification from './getAllBonification'
import { addBonifications } from './addBonifications'
import { updateBonifications } from './updateBonifications'
import { getBrandsByCarLots } from './getBrandsByCarLots'
import { getModelsByBrandName } from './getModelsByBrandName'
import { getVersionByModelName } from './getVersionByModelName'
import { getBranchOfficeByCarLots } from './getBranchOfficeByCarLots'
import { getAllConventionalBonifications } from './getAllConventionalBonifications'
import getAllConventionalBonificationsByVersions from './getAllConventionalBonificationsByVersions'
import { createOrUpdateBonificationByModelId } from './createOrUpdateBonificationByModelId'
import {updateConventionalIndividualBonifications} from './updateConventionalIndividualBonifications'
import { createOrUpdateBonificationByVersion } from './createOrUpdateBonificationByVersion'
import { createOrUpdateBonificationByStock } from './createOrUpdateBonificationByStock'
import { getAllConventionalBonificationsByStock } from './getAllConventionalBonificationsByStock'
import { getFactoryCarLotDiscount } from './getFactoryCarLotDiscount'
import { saveRolesBonifications } from './saveRolesBonifications'
import { getRolesBonifications } from './getRolesBonifications'
import { getAllDirectBonification } from './getAllDirectBonification'
import { getAllDirectBonificationsByVersions } from './getAllDirectBonificationsByVersions'
import { createOrUpdateDirectByModel } from './createOrUpdateDirectByModel'
import { createOrUpdateDirectByVersion } from './createOrUpdateDirectByVersion'

export const PricePolicy = {
  getAllBonification,
  addBonifications,
  getBrandsByCarLots,
  getModelsByBrandName,
  getVersionByModelName,
  getBranchOfficeByCarLots,
  updateBonifications,
  getAllConventionalBonifications,
  getAllConventionalBonificationsByVersions,
  createOrUpdateBonificationByModelId,
  updateConventionalIndividualBonifications,
  createOrUpdateBonificationByVersion,
  createOrUpdateBonificationByStock,
  getAllConventionalBonificationsByStock,
  getFactoryCarLotDiscount,
  saveRolesBonifications,
  getRolesBonifications,
  getAllDirectBonification,
  getAllDirectBonificationsByVersions,
  createOrUpdateDirectByModel,
  createOrUpdateDirectByVersion
}
